import React, {createContext, useReducer} from 'react'

const Reducer = (data, payload) => {
  switch (payload.type) {
    case 'header': {
      return { ...data, ...payload.data, loader: {}, notification: {} }
    }
    case 'notification': {
      return { ...data, notification: payload.data, loader: {} }
    }
    case 'loader': {
      return {
        ...data,
        loader: payload.data,
        notification: payload.notification,
      }
    }
    // Clears everything the signed-in session put here - header, breadcrumb,
    // permissions, username - while still carrying a notification through, so
    // the "logged out" toast survives the reset. Logout is the only sign-out
    // path that navigates client-side; the others assign window.location.href,
    // which reloads the document and resets this store anyway.
    case 'reset': {
      return { ...initialState, notification: payload.data || {} }
    }
    case 'permissions': {
      return {
        ...data,
        permissions: payload.data,
        make: payload.make,
        username: payload.username,
        is_admin: payload.is_admin,
      }
    }
    default: {
      return {}
    }
  }
}

const initialState = {
  header: null,
  sub_header: null,
  show_back_btn: true,
  notification: {},
  loader: {},
  permissions: [],
  make: null,
  show_home_button: false,
  username: null,
  is_admin: false,
}

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)

  return (
    <NavContext.Provider value={[state, dispatch]}>
      {children}
    </NavContext.Provider>
  )
}

export const NavContext = createContext(initialState)
export default Store
